module.exports = __webpack_public_path__ + "static/media/D-DIN.386c9445.otf";